import MDB from '../marketingdb'

export default {
    get getFileIcon() {
        return MDB.Icons.getFileIcon; 
    }
}